import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import {
  dashboardWidgetIconSx,
  dashboardWidgetTitleRowSx,
  dashboardWidgetTitleSx,
} from "./dashboardWidgetLayout";

interface AnalyticsWidgetHeaderProps {
  title: string;
  icon: ReactNode;
  iconBg?: string;
  iconColor?: string;
}

/** Small, clean icon + title for Analytics dashboard widgets */
export default function AnalyticsWidgetHeader({
  title,
  icon,
  iconBg = "#EEF2FF",
  iconColor = "#4F46E5",
}: AnalyticsWidgetHeaderProps) {
  return (
    <Box sx={dashboardWidgetTitleRowSx}>
      <Box
        className="dashboard-widget-icon"
        sx={{
          ...dashboardWidgetIconSx,
          width: 28,
          height: 28,
          borderRadius: "8px",
          backgroundColor: iconBg,
          color: iconColor,
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          "& svg": { fontSize: 15 },
        }}
      >
        {icon}
      </Box>
      <Typography
        className="font-Saira"
        sx={{
          ...dashboardWidgetTitleSx,
          minWidth: 0,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}